
(function () {
  'use strict';

  function initTopFilters() {

    const dropdownSelector =
      '.filter-selectors, .filter-col-selector-wrap';

    const dropdowns = document.querySelectorAll(dropdownSelector);

    // Close all dropdowns except the specified one
    function closeDropdowns(except = null) {
      document.querySelectorAll(
        dropdownSelector
      ).forEach(function(wrapper) {

        const title = wrapper.querySelector(
          '.filter-selector-title'
        );

        if (!title || title === except) return;

        title.classList.remove('active');
        title.setAttribute('aria-expanded', 'false');
      });
    }

    // Initialize dropdown
    function initDropdown(wrapper) {

      if (!wrapper || wrapper.dataset.filterInitialized === 'true') {
        return;
      }

      const title = wrapper.querySelector(
        '.filter-selector-title'
      );

      const value = wrapper.querySelector(
        '.filter-selector-val'
      );

      const list = wrapper.querySelector(
        '.filter__list'
      );

      const options = wrapper.querySelectorAll(
        '.filter__list li'
      );

      if (!title || !value || !list) return;

      wrapper.dataset.filterInitialized = 'true';

      title.setAttribute('aria-expanded', 'false');

      // Open and close dropdown
      title.addEventListener('click', function(event) {

        event.preventDefault();
        event.stopPropagation();

        const wasOpen = title.classList.contains('active');

        closeDropdowns();

        title.classList.toggle('active', !wasOpen);

        title.setAttribute(
          'aria-expanded',
          String(!wasOpen)
        );
      });

      // Handle option selection
      options.forEach(function(option) {

        option.addEventListener('click', function(event) {

          event.preventDefault();
          event.stopPropagation();

          options.forEach(function(item) {
            item.classList.remove('current');
          });

          option.classList.add('current');

          const optionText = option.querySelector(
            '.filter-checkbox__text'
          );

          if (optionText) {
            value.textContent = optionText.textContent.trim();
          }

          value.setAttribute(
            'data-value-selected',
            'true'
          );

          closeDropdowns();
        });
      });
    }

    dropdowns.forEach(initDropdown);

    // Close dropdown when clicking outside
    document.addEventListener('click', function(event) {

      if (!event.target.closest(dropdownSelector)) {
        closeDropdowns();
      }
    });

    // Close dropdown on Escape key
    document.addEventListener('keydown', function(event) {

      if (event.key === 'Escape') {
        closeDropdowns();
      }
    });

    // Get selected dropdown option
    function getSelectedOption(wrapperSelector) {

      const wrapper = document.querySelector(wrapperSelector);

      if (!wrapper) return null;

      const value = wrapper.querySelector(
        '.filter-selector-val'
      );

      if (
        !value ||
        value.getAttribute('data-value-selected') !== 'true'
      ) {
        return null;
      }

      return wrapper.querySelector(
        '.filter__item.current .filter-checkbox__text'
      );
    }

    // Search and collection redirect
    document.querySelectorAll(
      '.filter-search-btn'
    ).forEach(function(button) {

      if (button.dataset.filterSearchInitialized === 'true') {
        return;
      }

      button.dataset.filterSearchInitialized = 'true';

      button.addEventListener('click', function(event) {

        event.preventDefault();
        event.stopPropagation();

        const modal = button.closest(
          '.filter-search-modal'
        );

        const searchInput = modal
          ? modal.querySelector('.search__input')
          : document.querySelector('.search__input');

        const searchTerm = searchInput
          ? searchInput.value.trim()
          : '';

        const selectedCollection = getSelectedOption(
          '.filter-col-selector-wrap'
        );

        const selectedFilter = getSelectedOption(
          '.filter-selectors'
        );

        const collectionHandle = selectedCollection
          ? selectedCollection.getAttribute(
              'data-collection-handle'
            )
          : null;

        const filterValue = selectedFilter
          ? selectedFilter.getAttribute('data-value')
          : null;

        const searchUrl = button.getAttribute(
          'data-search-url'
        ) || '/search';

        let url;

        // Search term entered
        if (searchTerm) {

          url = new URL(
            searchUrl,
            window.location.origin
          );

          url.searchParams.set('sort_by', 'relevance');
          url.searchParams.set('q', searchTerm);

          if (filterValue) {
            url.searchParams.set(
              'filter.p.t.category',
              filterValue
            );
          }

        }

        // Collection selected, no search term
        else if (collectionHandle) {

          const collectionUrl = '/collections/' + collectionHandle;

          url = new URL(collectionUrl, window.location.origin);

          url.searchParams.set('sort_by', 'title-ascending');

          if (filterValue) {
            url.searchParams.set('filter.p.t.category', filterValue);
          }

          console.log('Selected collection:', collectionHandle);
          console.log('Redirecting to:', url.toString());
        }

        // Only category filter selected
        else if (filterValue) {

          url = new URL(
            '/search',
            window.location.origin
          );

          url.searchParams.set(
            'sort_by',
            'title-ascending'
          );

          url.searchParams.set(
            'filter.p.t.category',
            filterValue
          );

        }

        // Nothing selected
        else {

          url = new URL(
            searchUrl,
            window.location.origin
          );

          if (searchTerm) {
            url.searchParams.set('q', searchTerm);
          }
        }

        window.location.assign(url.toString());

      });
    });

  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initTopFilters
    );

  } else {

    initTopFilters();

  }

})();
